import membershipPeriod from '$modules/membershipPeriod/routes'
import membershipType from '$modules/membershipType/routes'

export default [
  {
    path: 'membership',
    meta: {
      title: 'Membership',
      auth: ['Admin', 'Super Admin'],
      hidden: false,
      icon: 'card_membership'
    },
    component: () => import('./pages/index'),
    redirect: 'membership/list',
    children: [
      {
        path: 'list',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'List',
          resource: 'membership',
          icon: 'playlist_add_check',
          hidden: false
        },
        component: () => import('./pages/list')
      },
      {
        path: 'edit/:id',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'Edit',
          resource: 'membership',
          icon: 'mode_edit',
          hidden: true
        },
        component: () => import('./pages/edit')
      },
      {
        path: 'add',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'Add',
          resource: 'membership',
          icon: 'add_circle_outline',
          hidden: false
        },
        component: () => import('./pages/add')
      }
    ].concat(membershipPeriod, membershipType)
  }
]
